const CONVERTKIT_API_KEY = process.env.REACT_APP_CONVERTKIT_API_KEY;
const CONVERTKIT_FORM_ID = process.env.REACT_APP_CONVERTKIT_FORM_ID;
const API_URL = 'https://api.convertkit.com/v3';

export const submitToConvertKit = async (data) => {
  try {
    const response = await fetch(`${API_URL}/forms/${CONVERTKIT_FORM_ID}/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        api_key: CONVERTKIT_API_KEY,
        email: data.email,
        fields: {
          business_type: data.businessType,
          current_tools: Array.isArray(data.currentTools) ? data.currentTools.join(', ') : data.currentTools,
          growth_focus: data.growthFocus,
          ai_experience: data.aiExperience,
          biggest_challenge: data.biggestChallenge,
          time_commitment: data.timeCommitment,
          success_story_permission: data.successStoryPermission,
          application_result: data.applicationResult,
          application_confidence: data.applicationConfidence,
          application_key_factors: data.applicationKeyFactors,
          application_risk_factors: data.applicationRiskFactors,
          application_onboarding_focus: data.applicationOnboardingFocus
        },
        tags: ['beta-application']
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to submit to ConvertKit');
    }

    return await response.json();
  } catch (error) {
    console.error('ConvertKit submission error:', error);
    throw error;
  }
}; 